// ---- components/About.js ----
export function About() {
  return (
    <section id="about" className="px-6 py-16 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-1">
        Order Processing Made Intelligent
      </h2>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        Ethos AI PO Processing revolutionizes your order management by automatically extracting data from customer 
        purchase orders and generating sales orders directly into your ERP system. Using advanced machine learning 
        and computer vision, our solution eliminates manual data entry, reduces processing errors, and accelerates 
        your order-to-cash cycle. With intelligent data validation and seamless ERP integration, we transform your 
        order processing from a time-consuming manual task to an efficient, automated workflow.
      </p>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Automated data extraction from customer POs
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          AI-powered document processing
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Direct ERP integration for sales orders
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Reduced manual entry & human errors
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Faster order processing cycles
        </div>
        <div className="flex items-center">
          <span className="text-green-500 mr-2">✓</span>
          Intelligent data validation & matching
        </div>
      </div>
    </section>
  );
}